import { INew_TableFilterRule, New_TableOperator } from '@lla-platform/core/core-data-access'
import { ISelectItem } from '@lla-platform/core/core-ui'

const New_TableOperatorToLabel: { [key in New_TableOperator]: string } = {
  LessThan: 'Less than',
  LessThanOrEqual: 'Less than or equal',
  Equals: 'Equals',
  NotEquals: 'Not equal',
  GreaterThanOrEqual: 'Greater than or equal',
  GreaterThan: 'Greater than',
  Contains: 'Contains',
  NotContains: 'Not contains',
  StartsWith: 'Starts with',
  EndsWith: 'Ends with',
  Period: 'Period',
  IsEmpty: 'Is empty',
  IsNotEmpty: 'Is not empty'
}

// IsEmpty / IsNotEmpty carry no value: their sentence is the whole rule
export function isEmptinessOperator(operator: New_TableOperator) {
  return operator === New_TableOperator.IsEmpty || operator === New_TableOperator.IsNotEmpty
}

// A rule filters when it has a value, or needs none
export function isActiveRule(rule: INew_TableFilterRule) {
  return (
    isEmptinessOperator(rule.operator) ||
    (rule.value !== null && rule.value !== undefined && rule.value !== '')
  )
}

export const New_TableOperatorToSentence: { [key in New_TableOperator]: string } = {
  LessThan: 'less than',
  LessThanOrEqual: 'less than or equal to',
  Equals: 'equal to',
  NotEquals: 'not equal to',
  GreaterThanOrEqual: 'greater than or equal to',
  GreaterThan: 'greater than',
  Contains: 'contains',
  NotContains: 'not contains',
  StartsWith: 'starts with',
  EndsWith: 'ends with',
  Period: 'in',
  IsEmpty: 'is empty',
  IsNotEmpty: 'is not empty'
}

// Offered on nullable number columns, after New_NumberOperators
export const New_EmptinessOperators: ISelectItem[] = [
  {
    label: New_TableOperatorToLabel.IsEmpty,
    value: 'IsEmpty'
  },
  {
    label: New_TableOperatorToLabel.IsNotEmpty,
    value: 'IsNotEmpty'
  }
]

export const New_StringOperators: ISelectItem[] = [
  {
    label: New_TableOperatorToLabel.Contains,
    value: 'Contains'
  },
  {
    label: New_TableOperatorToLabel.Equals,
    value: 'Equals'
  },
  {
    label: New_TableOperatorToLabel.NotEquals,
    value: 'NotEquals'
  },
  {
    label: New_TableOperatorToLabel.StartsWith,
    value: 'StartsWith'
  },
  {
    label: New_TableOperatorToLabel.EndsWith,
    value: 'EndsWith'
  }
]

export const New_NumberOperators: ISelectItem[] = [
  {
    label: New_TableOperatorToLabel.LessThanOrEqual,
    value: 'LessThanOrEqual'
  },
  {
    label: New_TableOperatorToLabel.LessThan,
    value: 'LessThan'
  },
  {
    label: New_TableOperatorToLabel.Equals,
    value: 'Equals'
  },
  {
    label: New_TableOperatorToLabel.NotEquals,
    value: 'NotEquals'
  },
  {
    label: New_TableOperatorToLabel.GreaterThan,
    value: 'GreaterThan'
  },
  {
    label: New_TableOperatorToLabel.GreaterThanOrEqual,
    value: 'GreaterThanOrEqual'
  }
]

export const New_NumberOperatorSymbols: Partial<Record<New_TableOperator, string>> = {
  [New_TableOperator.LessThan]: '<',
  [New_TableOperator.LessThanOrEqual]: '≤',
  [New_TableOperator.Equals]: '=',
  [New_TableOperator.NotEquals]: '≠',
  [New_TableOperator.GreaterThan]: '>',
  [New_TableOperator.GreaterThanOrEqual]: '≥'
}

export const TotalRowUniqueId = 'advanced_table_total_row_unique_id'

export const BooleanEnumItems: ISelectItem[] = [
  {
    label: 'True',
    value: true
  },
  {
    label: 'False',
    value: false
  }
]

export const BooleanEnumYesNoItems: ISelectItem[] = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
]
